import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import mediaService from "@/services/media";

export const useMediaStore = defineStore("media", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchAllMediaGrid(companyId) {
    loading.value = true;
    try {
      const res = await mediaService.getAllMediaGrid(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAllMedia(companyId) {
    loading.value = true;
    try {
      const res = await mediaService.getAllMedia(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addMedia(payload) {
    loading.value = true;
    try {
      const res = await mediaService.addMedia(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function bulkDeleteMedia(payload) {
    loading.value = true;
    try {
      const res = await mediaService.bulkDeleteMedia(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchAllMediaGrid,
    fetchAllMedia,
    addMedia,
    bulkDeleteMedia,
  };
});
